export const TRANSACTION_STATUS = {
  COMPLETE: "COMPLETE",
  PENDING: "PENDING",
  EXPIRED: "EXPIRED",
  NOT_PAID: "NOT-PAID",
  REFUNDED: "REFUNDED",
  CANCELLED: "CANCELLED",
  CHARGEBACK: "CHARGEBACK",
  UNDER_REVIEW: "UNDER-REVIEW",
  CREATED_HOSTED_CHECKOUT: "CREATED_HOSTED_CHECKOUT",
}

export const TRANSACTION_STATUS_FILTER_LIST = [
  {
    text: "Aprovado",
    value: TRANSACTION_STATUS.COMPLETE,
  },
  {
    text: "Pendente",
    value: TRANSACTION_STATUS.PENDING,
  },
  {
    text: "Expirado",
    value: TRANSACTION_STATUS.EXPIRED,
  },
  {
    text: "Não pago",
    value: TRANSACTION_STATUS.NOT_PAID,
  },
  {
    text: "Reembolso",
    value: TRANSACTION_STATUS.REFUNDED,
  },
  {
    text: "Cancelado",
    value: TRANSACTION_STATUS.CANCELLED,
  },
  {
    text: "Estorno",
    value: TRANSACTION_STATUS.CHARGEBACK,
  },
  {
    text: "Em análise",
    value: TRANSACTION_STATUS.UNDER_REVIEW,
  },
  {
    text: "Boa Compra",
    value: TRANSACTION_STATUS.CREATED_HOSTED_CHECKOUT,
  },
]

export const TRANSACTION_STATUS_DESCRIPTION = {
  [TRANSACTION_STATUS.COMPLETE]: {
    text: "Aprovado",
    color: "success",
  },
  [TRANSACTION_STATUS.PENDING]: {
    text: "Pendente",
    color: "blue darken-2",
  },
  [TRANSACTION_STATUS.NOT_PAID]: {
    text: "Não pago",
    color: "grey lighten-2",
  },
  [TRANSACTION_STATUS.UNDER_REVIEW]: {
    text: "Em análise",
    color: "yellow darken-2",
  },
  [TRANSACTION_STATUS.EXPIRED]: {
    text: "Expirado",
    color: "error",
  },
  [TRANSACTION_STATUS.CANCELLED]: {
    text: "Cancelado",
    color: "error",
  },
  [TRANSACTION_STATUS.CHARGEBACK]: {
    text: "Estorno",
    color: "grey darken-3",
  },
  [TRANSACTION_STATUS.REFUNDED]: {
    text: "Reembolso",
    color: "blue darken-1",
  },
  [TRANSACTION_STATUS.CREATED_HOSTED_CHECKOUT]: {
    text: "Boa Compra",
    color: "orange",
  },
}

export const TRANSACTION_TYPE = {
  IMAGE_PROCESSING: "IMAGE_PROCESSING",
  POST_PROCESSING: "POST_PROCESSING",
  SUBSCRIPTION: "SUBSCRIPTION",
  SUBSCRIPTION_UPDATE: "SUB_UP",
  PHYSICAL_PRODUCT: "PHYSICAL_PRODUCT",
}

export const TRANSACTION_TYPE_DESCRIPTION = {
  [TRANSACTION_TYPE.IMAGE_PROCESSING]: {
    text: "Processamento de imagem",
  },
  [TRANSACTION_TYPE.POST_PROCESSING]: {
    text: "Análise agronômica",
  },
  [TRANSACTION_TYPE.SUBSCRIPTION]: {
    text: "Assinatura",
  },
  [TRANSACTION_TYPE.SUBSCRIPTION_UPDATE]: {
    text: "Atualização de Assinatura",
  },
  [TRANSACTION_TYPE.PHYSICAL_PRODUCT]: {
    text: "Produto físico",
  },
}

export const MOCKED_TRANSACTION_LIST = [{
  "ab_country": "BR",
  "ab_currency": "BRL",
  "ab_payment_type": "credit-card",
  "ab_refuse_reason": null,
  "ab_status": "NOT-PAID",
  "ab_transaction_type": "SUBSCRIPTION",
  "boleto_bancario": null,
  "cd_external_code": "130221080",
  "cd_internal_hash": "C1564A762AF843B08B9982D45B20D00D",
  "cd_price_product": null,
  "cd_promotion": null,
  "cd_promotion_plan": null,
  "cd_reference": "SUBSCRIPTION-77BA29B16293481EA5E6A715D648627E-86-00000-DC3B6",
  "cd_subscription_plan": 1,
  "cd_user": 86,
  "dh_created": "2019-04-13T20:59:47.175629+00:00",
  "dh_finished": null,
  "dh_updated": "2019-04-13T21:00:45.177801+00:00",
  "fl_discount": 0,
  "fl_final_price": 39.9,
  "fl_total_price": 39.9,
  "id_transaction": 56,
  "int_credits_used": 0,
  "price_product": null,
  "promotion": null,
  "promotion_plan": null,
  "str_transaction_email": "guiih.ig@gmail.com",
  "subscription_plan": {
    "ab_payable_with": "credit-card",
    "ab_subscription_plan": "MONTH_LIMITED_39",
    "bl_credits_stackable": true,
    "bl_default_auto_renew": true,
    "id_subscription_plan": 1,
    "int_months_interval": 1,
    "int_subscription_level": 1,
    "lst_credits": [10000],
    "lst_intl_prices": [9.9],
    "lst_prices": [39.9],
    "nm_subscription_plan": "Plano Profissional",
  },
}, {
  "ab_country": "BR",
  "ab_currency": "BRL",
  "ab_payment_type": "no-type",
  "ab_refuse_reason": null,
  "ab_status": "COMPLETE",
  "ab_transaction_type": "POST_PROCESSING",
  "boleto_bancario": null,
  "cd_external_code": "NO_CODE",
  "cd_internal_hash": "DE4AEAAE06504D659F4D05406D6EC418",
  "cd_price_product": 27,
  "cd_promotion": null,
  "cd_promotion_plan": null,
  "cd_reference": "POST_PROCESSING-25_26_27-401_402_403-86-424C8",
  "cd_subscription_plan": null,
  "cd_user": 86,
  "dh_created": "2019-04-13T21:07:59.829941+00:00",
  "dh_finished": null,
  "dh_updated": null,
  "fl_discount": 0,
  "fl_final_price": 0,
  "fl_total_price": 75.9,
  "id_transaction": 57,
  "int_credits_used": 7589,
  "price_product": {
    "ab_payable_with": "ALL",
    "fl_base_price": 2,
    "fl_intl_base_price": 0.5,
    "fl_intl_start_price": 0,
    "fl_start_price": 0,
    "id_price_product": 27,
  },
  "promotion": null,
  "promotion_plan": null,
  "str_transaction_email": "guiih.ig@gmail.com",
  "subscription_plan": null,
}, {
  "ab_country": "BR",
  "ab_currency": "BRL",
  "ab_payment_type": "no-type",
  "ab_refuse_reason": null,
  "ab_status": "COMPLETE",
  "ab_transaction_type": "POST_PROCESSING",
  "boleto_bancario": null,
  "cd_external_code": "NO_CODE",
  "cd_internal_hash": "BE694BC746B74D8997C3417D76B6F14D",
  "cd_price_product": 27,
  "cd_promotion": null,
  "cd_promotion_plan": null,
  "cd_reference": "POST_PROCESSING-25_26_27-1337-86-A9430",
  "cd_subscription_plan": null,
  "cd_user": 86,
  "dh_created": "2019-04-13T21:26:51.827211+00:00",
  "dh_finished": null,
  "dh_updated": null,
  "fl_discount": 0,
  "fl_final_price": 0,
  "fl_total_price": 50,
  "id_transaction": 61,
  "int_credits_used": 5000,
  "price_product": {
    "ab_payable_with": "ALL",
    "fl_base_price": 2,
    "fl_intl_base_price": 0.5,
    "fl_intl_start_price": 0,
    "fl_start_price": 0,
    "id_price_product": 27,
  },
  "promotion": null,
  "promotion_plan": null,
  "str_transaction_email": "guiih.ig@gmail.com",
  "subscription_plan": null,
}, {
  "ab_country": "BR",
  "ab_currency": "BRL",
  "ab_payment_type": "credit-card",
  "ab_refuse_reason": null,
  "ab_status": "COMPLETE",
  "ab_transaction_type": "POST_PROCESSING",
  "boleto_bancario": null,
  "cd_external_code": "130230741",
  "cd_internal_hash": "29853E9C54C74721984C31FA96D3418E",
  "cd_price_product": 26,
  "cd_promotion": null,
  "cd_promotion_plan": null,
  "cd_reference": "POST_PROCESSING-26-1338-86-CF9F8",
  "cd_subscription_plan": null,
  "cd_user": 86,
  "dh_created": "2019-04-13T22:05:16.914003+00:00",
  "dh_finished": null,
  "dh_updated": "2019-04-13T22:05:28.824050+00:00",
  "fl_discount": 0,
  "fl_final_price": 5,
  "fl_total_price": 50,
  "id_transaction": 62,
  "int_credits_used": 0,
  "price_product": {
    "ab_payable_with": "ALL",
    "fl_base_price": 0.5,
    "fl_intl_base_price": 0.125,
    "fl_intl_start_price": 0,
    "fl_start_price": 0,
    "id_price_product": 26,
  },
  "promotion": null,
  "promotion_plan": null,
  "str_transaction_email": "guiih.ig@gmail.com",
  "subscription_plan": null,
}, {
  "ab_country": "BR",
  "ab_currency": "BRL",
  "ab_payment_type": "postpay",
  "ab_refuse_reason": null,
  "ab_status": "NOT-PAID",
  "ab_transaction_type": "POST_PROCESSING",
  "boleto_bancario": {
    "dh_created": "2019-04-13T22:57:58.794082+00:00",
    "str_barcode_number": "03393786200000051509853029700000269691010101",
    "str_digitable_line": "03399853012970000026796910101011378620000005150",
    "url_boleto": "https://payment.boacompra.com/b/TXBWbXVvT25EYWxiK0lsTzVlY0tIZz09",
  },
  "cd_external_code": "130237673",
  "cd_internal_hash": "E8A86ECD37F5414CB99373BEE34A0F57",
  "cd_price_product": 27,
  "cd_promotion": null,
  "cd_promotion_plan": null,
  "cd_reference": "POST_PROCESSING-27-1338-86-32516",
  "cd_subscription_plan": null,
  "cd_user": 86,
  "dh_created": "2019-04-13T22:57:58.866143+00:00",
  "dh_finished": null,
  "dh_updated": "2019-04-27T12:38:51.899956+00:00",
  "fl_discount": 0,
  "fl_final_price": 50,
  "fl_total_price": 50,
  "id_transaction": 64,
  "int_credits_used": 0,
  "price_product": {
    "ab_payable_with": "ALL",
    "fl_base_price": 2,
    "fl_intl_base_price": 0.5,
    "fl_intl_start_price": 0,
    "fl_start_price": 0,
    "id_price_product": 27,
  },
  "promotion": null,
  "promotion_plan": null,
  "str_transaction_email": "guiih.ig@gmail.com",
  "subscription_plan": null,
}, {
  "ab_country": "BR",
  "ab_currency": "BRL",
  "ab_payment_type": "postpay",
  "ab_refuse_reason": null,
  "ab_status": "EXPIRED",
  "ab_transaction_type": "SUB_UP",
  "boleto_bancario": {
    "dh_created": "2019-05-03T23:54:52.005757+00:00",
    "str_barcode_number": "03392788300001000509853029700000280026630101",
    "str_digitable_line": "03399853012970000028300266301019278830000100050",
    "url_boleto": "https://payment.boacompra.com/b/L1dVcDBucCtzVmpzVGUxWEp0NjFwdz09",
  },
  "cd_external_code": "132519858",
  "cd_internal_hash": "D183C74E581B413585D1570CE56E5627",
  "cd_price_product": null,
  "cd_promotion": null,
  "cd_promotion_plan": null,
  "cd_reference": "SUB_UP-77BA29B16293481EA5E6A715D648627E-86-3-00000-E820E",
  "cd_subscription_plan": 3,
  "cd_user": 86,
  "dh_created": "2019-05-03T23:54:52.011619+00:00",
  "dh_finished": null,
  "dh_updated": "2019-05-18T04:37:32.153984+00:00",
  "fl_discount": 0,
  "fl_final_price": 999,
  "fl_total_price": 999,
  "id_transaction": 198,
  "int_credits_used": 0,
  "price_product": null,
  "promotion": null,
  "promotion_plan": null,
  "str_transaction_email": "guiih.ig@gmail.com",
  "subscription_plan": {
    "ab_payable_with": "ALL",
    "ab_subscription_plan": "MONTH_UNLIMITED_999",
    "bl_credits_stackable": true,
    "bl_default_auto_renew": true,
    "id_subscription_plan": 3,
    "int_months_interval": 1,
    "int_subscription_level": 3,
    "lst_credits": [20000],
    "lst_intl_prices": [249.9],
    "lst_prices": [999],
    "nm_subscription_plan": "Plano mensal - Ilimitado",
  },
}, {
  "ab_country": "BR",
  "ab_currency": "BRL",
  "ab_payment_type": "no-type",
  "ab_refuse_reason": null,
  "ab_status": "COMPLETE",
  "ab_transaction_type": "IMAGE_PROCESSING",
  "boleto_bancario": null,
  "cd_external_code": "NO_CODE",
  "cd_internal_hash": "0DA35A11F5C14FDE841969CC48865ABB",
  "cd_price_product": 35,
  "cd_promotion": null,
  "cd_promotion_plan": null,
  "cd_reference": "IMAGE_PROCESSING-3197-86-26AD3",
  "cd_subscription_plan": null,
  "cd_user": 86,
  "dh_created": "2019-05-23T16:27:59.369946+00:00",
  "dh_finished": null,
  "dh_updated": null,
  "fl_discount": 0,
  "fl_final_price": 0,
  "fl_total_price": 0,
  "id_transaction": 535,
  "int_credits_used": 0,
  "price_product": {
    "ab_payable_with": "ALL",
    "fl_base_price": 28,
    "fl_intl_base_price": 7,
    "fl_intl_start_price": 0,
    "fl_start_price": 0,
    "id_price_product": 35,
  },
  "promotion": null,
  "promotion_plan": null,
  "str_transaction_email": "guiih.ig@gmail.com",
  "subscription_plan": null,
}, {
  "ab_country": "BR",
  "ab_currency": "BRL",
  "ab_payment_type": "postpay",
  "ab_refuse_reason": null,
  "ab_status": "EXPIRED",
  "ab_transaction_type": "IMAGE_PROCESSING",
  "boleto_bancario": {
    "dh_created": "2019-05-24T18:48:09.460978+00:00",
    "str_barcode_number": "03391790400000054199853029700000292900190101",
    "str_digitable_line": "03399853012970000029129001901015179040000005419",
    "url_boleto": "https://payment.boacompra.com/b/Y0xhWXpINmpmclFRVGhHanV1cnVVZz09",
  },
  "cd_external_code": "135996400",
  "cd_internal_hash": "0F38052F30AB450BB5AE6D8B4DE3FF61",
  "cd_price_product": 73,
  "cd_promotion": null,
  "cd_promotion_plan": null,
  "cd_reference": "IMAGE_PROCESSING-3253-86-18DDC",
  "cd_subscription_plan": null,
  "cd_user": 86,
  "dh_created": "2019-05-24T18:48:09.477072+00:00",
  "dh_finished": null,
  "dh_updated": "2019-06-08T04:33:01.612753+00:00",
  "fl_discount": 0,
  "fl_final_price": 52.69,
  "fl_total_price": 52.69,
  "id_transaction": 566,
  "int_credits_used": 0,
  "price_product": {
    "ab_payable_with": "ALL",
    "fl_base_price": 28,
    "fl_intl_base_price": 28,
    "fl_intl_start_price": 20,
    "fl_start_price": 50,
    "id_price_product": 73,
  },
  "promotion": null,
  "promotion_plan": null,
  "str_transaction_email": "guiih.ig@gmail.com",
  "subscription_plan": null,
}, {
  "ab_country": "BR",
  "ab_currency": "BRL",
  "ab_payment_type": "postpay",
  "ab_refuse_reason": null,
  "ab_status": "NOT-PAID",
  "ab_transaction_type": "IMAGE_PROCESSING",
  "boleto_bancario": {
    "dh_created": "2019-05-15T00:13:43.998440+00:00",
    "str_barcode_number": "03399789200000004199853029700000286540390101",
    "str_digitable_line": "03399853012970000028365403901013978920000000419",
    "url_boleto": "https://payment.boacompra.com/b/c1pvVktZbjRSQ3RHZGZCZXpOY2hhZz09",
  },
  "cd_external_code": "134090671",
  "cd_internal_hash": "ADFDD4ADEB054FF2868C8EBFE11C5E2C",
  "cd_price_product": 35,
  "cd_promotion": null,
  "cd_promotion_plan": null,
  "cd_reference": "IMAGE_PROCESSING-2737-86-A1004",
  "cd_subscription_plan": null,
  "cd_user": 86,
  "dh_created": "2019-05-15T00:13:44.008469+00:00",
  "dh_finished": null,
  "dh_updated": "2019-05-27T11:20:52.760038+00:00",
  "fl_discount": 0,
  "fl_final_price": 2.69,
  "fl_total_price": 2.69,
  "id_transaction": 325,
  "int_credits_used": 0,
  "price_product": {
    "ab_payable_with": "ALL",
    "fl_base_price": 28,
    "fl_intl_base_price": 7,
    "fl_intl_start_price": 0,
    "fl_start_price": 0,
    "id_price_product": 35,
  },
  "promotion": null,
  "promotion_plan": null,
  "str_transaction_email": "guiih.ig@gmail.com",
  "subscription_plan": null,
}, {
  "ab_country": "BR",
  "ab_currency": "BRL",
  "ab_payment_type": "credit-card",
  "ab_refuse_reason": null,
  "ab_status": "NOT-PAID",
  "ab_transaction_type": "SUB_UP",
  "boleto_bancario": null,
  "cd_external_code": "137890445",
  "cd_internal_hash": "D678EC1582FB4E77A988858E28F86092",
  "cd_price_product": null,
  "cd_promotion": null,
  "cd_promotion_plan": null,
  "cd_reference": "SUB_UP-77BA29B16293481EA5E6A715D648627E-86-4-00000-C1C29",
  "cd_subscription_plan": 4,
  "cd_user": 86,
  "dh_created": "2019-06-07T13:56:40.338186+00:00",
  "dh_finished": null,
  "dh_updated": "2019-06-07T13:56:45.500902+00:00",
  "fl_discount": 0,
  "fl_final_price": 5988,
  "fl_total_price": 5988,
  "id_transaction": 739,
  "int_credits_used": 0,
  "price_product": null,
  "promotion": null,
  "promotion_plan": null,
  "str_transaction_email": "guiih.ig@gmail.com",
  "subscription_plan": {
    "ab_payable_with": "ALL",
    "ab_subscription_plan": "YEAR_UNLIMITED_6000",
    "bl_credits_stackable": true,
    "bl_default_auto_renew": true,
    "id_subscription_plan": 4,
    "int_months_interval": 12,
    "int_subscription_level": 3,
    "lst_credits": [20000],
    "lst_intl_prices": [1498.8],
    "lst_prices": [5988],
    "nm_subscription_plan": "Plano anual - Ilimitado",
  },
}, {
  "ab_country": "BR",
  "ab_currency": "BRL",
  "ab_payment_type": "credit-card",
  "ab_refuse_reason": null,
  "ab_status": "NOT-PAID",
  "ab_transaction_type": "PHYSICAL_PRODUCT",
  "boleto_bancario": null,
  "cd_external_code": "138952940",
  "cd_internal_hash": "31578EF54E414FA1B829DDE8C24CF8E6",
  "cd_price_product": 75,
  "cd_promotion": null,
  "cd_promotion_plan": null,
  "cd_reference": "PHYSICAL_PRODUCT-PHANTOM_DAAS-86-23171",
  "cd_subscription_plan": null,
  "cd_user": 86,
  "dh_created": "2019-06-13T23:20:11.717173+00:00",
  "dh_finished": null,
  "dh_updated": "2019-06-13T23:21:13.041189+00:00",
  "fl_discount": 0,
  "fl_final_price": 6000,
  "fl_total_price": 6000,
  "id_transaction": 842,
  "int_credits_used": 0,
  "price_product": {
    "ab_payable_with": "ALL",
    "fl_base_price": 1,
    "fl_intl_base_price": 1,
    "fl_intl_start_price": 1500,
    "fl_start_price": 6000,
    "id_price_product": 75,
  },
  "promotion": null,
  "promotion_plan": null,
  "str_transaction_email": "guiih.ig@gmail.com",
  "subscription_plan": null,
}]
